import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";

// import JS files
import TableIconModal from "../../../shares/TableIconModal";
import EditRingForm from "../ring/EditRingForm";

// import Others files

const EditTableRing = (props) => {
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    if (openModal == true)
      if (props.selectedRow !== undefined)
        if (props.selectedRow.hasOwnProperty("id")) {
          props.getRingsApi.reFetch();
        }
  }, [openModal]);

  return (
    <>
      <TableIconModal
        width="w-4/5"
        icon={<EditIcon />}
        openModal={openModal}
        setOpenModal={setOpenModal}
      >
        <div>
          <div className="close-modal-icon">
            <CloseIcon
              onClick={() => setOpenModal(false)}
              fontSize="large"
              color="secondary"
            />
          </div>

          <EditRingForm
            openModal={openModal}
            setOpenModal={setOpenModal}
            getRingsApi={props.getRingsApi}
            item={props.selectedRow}
          />
        </div>
      </TableIconModal>
    </>
  );
};

export default EditTableRing;
